import { plainLetters } from "@/lib/jsonLd";

/**
 * The short description, with its line breaks kept. Nothing for an event
 * without one; it is what the page opens with rather than one section among
 * others, so it has no heading on the event's own page.
 */
export function EventDescription({ text, className = "" }: { text: string | null | undefined; className?: string }) {
  // with its letters as letters: see plainLetters
  const description = plainLetters(text).trim();
  if (!description) {
    return null;
  }
  return <p className={`whitespace-pre-line text-[15px] leading-relaxed text-ink ${className}`}>{description}</p>;
}
